var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlusIcon = function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#PlusIcon_svg__a)",
    d: "M6.027.457a.603.603 0 0 1 .604.603v4.626h4.625a.603.603 0 1 1 0 1.206H6.631v4.626a.603.603 0 1 1-1.207 0V6.892H.799a.603.603 0 1 1 0-1.206h4.625V1.06a.603.603 0 0 1 .603-.603"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "PlusIcon_svg__a",
    x1: 6.027,
    x2: 6.027,
    y1: -2.368,
    y2: 12.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#416BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBC9FA"
  })))));
};
export default SvgPlusIcon;